// account.js
let currentAccountId = null;

/**
 * 设置当前账号 ID
 * @param {string} id 
 */
export function setAccountId(id) {
  currentAccountId = id;
}

/**
 * 获取当前账号 ID
 * @returns {string|null}
 */
export function getAccountId() {
  return currentAccountId;
}
